import { Button } from "react-bootstrap";
import { getAttachments, imageUrl, url } from '../../../shared/services/apiService';
import BirthApplEdit from "./assessmentEdit/BirthApplEdit";
import { Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { getSearchInfo } from '../../../shared/utils/storage';

const AttachmentsInfo = ({ data }) => {
  const [application, setApplication] = useState()

  useEffect(() => {
    const searchedData = getSearchInfo()
    if (searchedData) {
      setApplication(searchedData?.data)
    }
  }, [])
  //let letNewData = useLocation().state;
  const attachments = application?.AttachmentInfo


  const [image, setImage] = useState();
  const [Name, setName] = useState();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  function handleShow(t, m) {
    setImage(t);
    setName(m);
    setShow(true);
  }

  const styles = {
    h4: {
      color: '#850505',
      textTransform: 'uppercase',
    }
  };

  return (
    <>
      <style>.center top: 50%; left: 50%;</style>
      <table id="viewTable">
        <thead>
        <tr>
          <th>
            <h4>
              <b>SN</b>
            </h4>
          </th>
          <th>
            <h4>
              <b>Name</b>
            </h4>
          </th>
          <th>
            <h4>
              <b>Action</b>
            </h4>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td style={{ width: "75%", color: "grey" }} colSpan="2">
            <b style={{ color: "green" }}></b>
          </td>

        </tr>

        {attachments?.map((obj, i) => (
          <tr key={obj.AttachmentPath || i}>
            <td style={{ verticalAlign: "middle" }}>
              <h4 style={styles.h4}>{i + 1}</h4>
            </td>
            <td style={{ verticalAlign: "middle" }}>
              <h4 style={styles.h4}>{obj.AttachmentName}</h4>
            </td>

            <td style={{ textAlign: "center" }}>
              <Button
                type="button"
                onClick={() => {
                  handleShow(obj.AttachmentPath, obj.AttachmentName);
                }}
                className="showModalButton btn icon-btn btn-info"
              >
                View
              </Button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>

      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="modal-title">{Name}</h5>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="position-relative mb-3">
            <center>
              {image ? (
                image.endsWith(".pdf") ? (
                  <embed
                    src={`${url}get_file?path=${encodeURIComponent(image)}`}
                    width="100%"
                    height="300px"
                    type="application/pdf"
                  />
                ) : (
                  <img
                    src={`${url}get_file?path=${encodeURIComponent(image)}`}
                    width="200px"
                    height="200px"
                    alt="Applicant"
                  />
                )
              ) : (
                <p>No file available</p>
              )}
            </center>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            style={{ background: "#ff4444", color: "white" }}
            onClick={handleClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AttachmentsInfo;
